import * as React from "react";
const SvgFiRrToolCrop = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-tool-crop_svg__a)">
      <path
        fill="#062147"
        d="M23 18h-3V9a5.006 5.006 0 0 0-5-5H6V1a1 1 0 0 0-2 0v3H1a1 1 0 0 0 0 2h3v9a5.006 5.006 0 0 0 5 5h9v3a1 1 0 0 0 2 0v-3h3a1 1 0 0 0 0-2M9 18a3 3 0 0 1-3-3V6h9a3 3 0 0 1 3 3v9z"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-tool-crop_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrToolCrop;
